import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Shared styling for date inputs and DatePicker for consistent UI across the app */
export const DATE_INPUT_CLASSNAME =
  "border-white/10 bg-black/40 text-white placeholder:text-white/40 focus:border-[#4da3ff]/50 focus:ring-[#4da3ff]/20 hover:border-white/20 transition-all duration-200";

